export default function normalizeNumberFilterValue(value, type, id) {
  if (type === 'float' || (id === 'duration' && value === '')) {
    return value;
  }

  return Number(value);
}
